import React from "react";
import { SectionHeading } from "@/components/home/SectionHeading";
import { PRODUCTS } from "@/data/catalog";

export const TwoStep = () => (
  <section className="bg-[#F8F5EF] py-16 md:py-24" data-testid="two-step">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <SectionHeading
        overline="The routine"
        title="The Baby Hemp Two-Step Routine"
        subtitle="Daily comfort from the balm, targeted protection from the patch."
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
        <Step
          n="01"
          img={PRODUCTS.balm.image}
          title="Calm Balm Stick"
          text="Moisturise and comfort dry, sensitive skin with a mess-free, glide-on balm."
        />
        <Step
          n="02"
          img={PRODUCTS.patch.image}
          title="Skin Barrier Protection Patches"
          text="Cover irritated areas to help protect from scratching and rubbing while supporting the skin barrier."
        />
      </div>
    </div>
  </section>
);

const Step = ({ n, img, title, text }) => (
  <div className="bg-white rounded-3xl p-7 md:p-9 flex flex-col gap-6 shadow-[0_4px_24px_rgba(111,80,58,0.05)]">
    <div className="aspect-[4/3] rounded-2xl bg-[#F8F5EF] overflow-hidden">
      <img src={img} alt={title} loading="lazy" className="w-full h-full object-contain p-4" />
    </div>
    <div className="flex items-start gap-4">
      <span className="font-heading text-2xl font-semibold text-[#B8C4A3]">{n}</span>
      <div>
        <h3 className="font-heading text-xl font-semibold text-[#6F503A] mb-2">{title}</h3>
        <p className="text-[#6F503A]/70 leading-relaxed">{text}</p>
      </div>
    </div>
  </div>
);
